<template>
  <div class="header-center-main" :class="user.targetCss.bgClass">
    <div v-if="showMain" class="grid grid--wide header-center-main__central-block">
      <div class="xs-12 dea-bg-white header-center-main__profile-block" :class="user.targetCss.borderMod">
        <div class="header-center-main__logo-container logos-container">
          <img
            class="header-center-main__deascuola-logo header--center__logo"
            :src="$root.config.logos[0].screenSize.desktop"
            alt="Logo Deascuola"
          />
          <img
            class="header-center-main__area-personale-logo header--center__logo"
            :src="personalAreaLogo"
            alt="Logo Area personale"
          />
        </div>
        <div class="header-center-main__profile-data-container" :class="user.targetCss.borderMod">
          <div class="header-center-main__avatar">
            <div class="header-center-main__avatar-background"></div>
            <img class="header-center-main__avatar-image" :src="user.avatar_icon" alt="icona utente" />
          </div>
          <div class="header-center-main__profile-data">
            <div class="header-center-main__profile-name">
              <span class="header-center-main__profile-of dea-heading--regular-m" :class="user.targetCss.borderMod"
                >di</span
              >
              <span
                class="header-center-main__profile-firstname dea-heading--medium-xxxl"
                :class="user.targetCss.borderMod"
              >
                {{ user.firstname }}
              </span>
            </div>
            <div class="header-center-main__profile-email dea-heading--regular-l">{{ user.email }}</div>
          </div>
        </div>
        <div class="header-center-main__modify-profile">
          <Buttons
            type="a"
            class="dea-button dea-button--small dea-button--circle"
            icon="edit"
            :href="profileUrl"
          ></Buttons>
        </div>
      </div>
    </div>

    <header v-else class="site-header">
      <div class="dea-main-header dea-main-header--ap">
        <div class="dea-main-header__dea-logo">
          <a href="https://deascuola.it" target="_blank">
            <img alt="Deascuola Logo" class="dea-main-header__dea-logo-image" :src="$root.config.mainHeaderLogo" />
          </a>
        </div>
        <div class="dea-main-header__dea-logo dea-main-header__dea-logo--personal-area">
          <a href="/">
            <img
              class="header-center-main__area-personale-logo header--center__logo"
              :src="personalAreaLogo"
              alt="Logo Area personale"
            />
          </a>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import Buttons from "@/components/elements/Buttons";
import logoAltro from "~/assets/AP_logo_esteso_altro.svg";
import logoDocente from "~/assets/AP_logo_esteso_docente.svg";
import logoGenitore from "~/assets/AP_logo_esteso_famiglie.svg";
import logoStudente from "~/assets/AP_logo_esteso_studente.svg";
import notAuthLogo from "~/assets/AP_logo_esteso_grigio_chiaro.svg";

export default {
  name: "HeaderCenterMain",
  components: { Buttons },
  props: {
    user: {
      type: Object,
      required: true,
    },
    profileUrl: {
      type: String,
      default: "",
    },
    showMain: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      animationClass: "",
      isScrolled: null,
    };
  },
  computed: {
    personalAreaLogo() {
      let logo;
      if (this.user.teacher) {
        logo = logoDocente;
      } else if (this.user.student) {
        logo = logoStudente;
      } else if (this.user.parent) {
        logo = logoGenitore;
      } else if (this.user.generic) {
        logo = logoAltro;
      } else {
        logo = notAuthLogo;
      }
      return logo;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

$home-logo-height: 40px;
$avatar-background-left-spacing: 28px;
$user-name-width: 500px;

.header-center-main {
  &__central-block.grid.grid--wide {
    max-width: 1280px;
  }

  &__profile-block {
    align-items: center;
    border: $border-bold;
    border-radius: $border-radius-large;
    display: flex;
    padding: $space-x-small $space-base;
    position: relative;
    top: $space-base;
  }

  &__logo-container {
    align-items: center;
    border: 0;
    border-bottom: inherit;
    display: flex;
    flex-grow: 1;
    position: relative;
  }

  &__avatar {
    bottom: 50%;
    position: absolute;
    right: 100%;
    transform: translateY(50%);

    &-background {
      background: $dea-color-white;
      bottom: $space-s-large;
      height: $space-xx-small;
      left: $avatar-background-left-spacing;
      position: absolute;
      width: $space-x-large;
    }

    &-image {
      position: relative;
    }
  }

  &__deascuola-logo.header--center__logo {
    opacity: 0;
    transform: translateX(-$space-s-large);
    width: $dea-logo-size-header-small;
  }

  &__area-personale-logo.header--center__logo {
    height: $home-logo-height;
    transform: translateX(-$space-s-large);
    width: auto;
  }

  &__profile-data-container {
    display: flex;
    position: relative;
  }

  &__profile-name {
    align-items: flex-end;
    display: flex;

    & > span {
      border-bottom: $border-bold;
      line-height: 1;
    }

    span:last-of-type {
      max-width: $user-name-width;
      overflow-x: hidden;
      padding-left: $space-x-small;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  &__profile-email {
    white-space: nowrap;
  }

  &__profile-data {
    display: flex;
    flex-direction: column;
    padding-top: 22px;
  }

  &__modify-profile {
    align-self: flex-start;
    margin-left: $space-xx-large;
  }
}

.dea-main-header--ap {
  @include media("<=m") {
    display: none !important; //sass-lint:disable-line no-important
  }

  display: flex !important; //sass-lint:disable-line no-important
}
</style>
